import { render, staticRenderFns } from "./api_Json_test.vue?vue&type=template&id=8f9a1c96&scoped=true&lang=html"
import script from "./api_Json_test.vue?vue&type=script&lang=js"
export * from "./api_Json_test.vue?vue&type=script&lang=js"
import style0 from "./api_Json_test.vue?vue&type=style&index=0&id=8f9a1c96&prod&lang=css"
import style1 from "./api_Json_test.vue?vue&type=style&index=1&id=8f9a1c96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9a1c96",
  null
  
)

export default component.exports